export const LABEL_PREFIX = 'label:';

export function IsLabel(key: string) {
    return key.startsWith(LABEL_PREFIX);
}

export function GetLabelKey(key: string): string {
    return IsLabel(key) ? key.substring(LABEL_PREFIX.length) : key;
}

export function GetDisplayKey(key: string): string {
    return GetLabelKey(key);
}

export function CreateLabelKey(key: string): string {
    return `${LABEL_PREFIX}${key}`;
}

export function GetTagType(key: string): string {
    return IsLabel(key) ? 'label' : 'tag';
}

export function validateLabelKey(key: string): string | null {
    if (!key) return 'Label key is required';
    if (key.length > 63) return 'Max length is 63 characters';
    if (!/^[a-z]/.test(key)) return 'Must start with lowercase letter';
    if (!/^[a-z0-9_-]+$/.test(key)) return 'Only lowercase letters, numbers, underscores, and hyphens allowed';
    return null;
}

export function validateLabelValue(value: string): string | null {
    if (value.length > 63) return 'Max length is 63 characters';
    if (value && !/^[a-z0-9_-]+$/.test(value)) return 'Only lowercase letters, numbers, underscores, and hyphens allowed';
    return null;
}
